/**
 * useDeleteUser Hook
 *
 * React Query mutation hook for deleting a user.
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { UseMutationResult } from '@tanstack/react-query';
import { userService } from '../../../api/user.service';
import { getErrorMessage } from '../../../lib/utils/errors';

/**
 * Hook for deleting a user
 */
export const useDeleteUser = (
  tenantId: string
): UseMutationResult<{ message: string }, Error, string> => {
  const queryClient = useQueryClient();

  return useMutation<{ message: string }, Error, string>({
    mutationFn: (userId) => {
      console.log('[useDeleteUser] Deleting user:', userId);
      return userService.deleteUser(tenantId, userId);
    },
    onSuccess: (_, userId) => {
      console.log('[useDeleteUser] User deleted successfully:', userId);
      // Remove from cache
      queryClient.removeQueries({ queryKey: ['user', tenantId, userId] });
      // Invalidate users list to refresh the data
      queryClient.invalidateQueries({ queryKey: ['users', tenantId] });
    },
    onError: (error) => {
      console.error('[useDeleteUser] Failed to delete user:', getErrorMessage(error));
    },
  });
};
